module.exports = __webpack_public_path__ + "static/working-advisor-hero-mobile.f916fe66.webp";